import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { WaterMeterModel } from "@/core/models/water-meter.model";
import {
    ChangeWaterMeterModel,
    WaterMeterChangeModel,
} from "@/core/models/water-meter-change.model";
import { ApiResponse } from "@/core/models/response.model";

interface _WaterMeterGetParams {
    search?: string;
    status?: string;
    createdBy?: string;
    waterUserId?: string;
}

@injectable()
export class WaterMeterRepo extends TableRepo<WaterMeterModel> {
    constructor() {
        super("/api/WaterMeter");
    }

    async getData(index: number, params: _WaterMeterGetParams, pageSize = 10): Promise<ApiPage<WaterMeterModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async changeMeter(model: ChangeWaterMeterModel): Promise<ApiResponse<WaterMeterChangeModel> | undefined> {
        try {
            const response = await this.apiRepo.post<WaterMeterChangeModel>(
                `${this.basepath}/change`,
                model
            );
            if (response?.code === "00") {
                this.changes.next(Date.now());
            }
            return response;
        } catch (err) {
            console.log(err);
        }
    }

    async getChanges(
        waterUserId: string,
        year?: number,
        month?: number
    ): Promise<WaterMeterChangeModel[]> {
        try {
            const params: Record<string, any> = { waterUserId };
            if (year != null) params.year = year;
            if (month != null) params.month = month;
            const response = await this.apiRepo.get<ApiPage<WaterMeterChangeModel>>(
                `${this.basepath}/changes`,
                params
            );
            if (response?.code === "00" && response.result) {
                return response.result.data ?? [];
            }
            return [];
        } catch (err) {
            console.log(err);
            return [];
        }
    }

    async cancelChange(id: string): Promise<ApiResponse<unknown> | undefined> {
        try {
            const response = await this.apiRepo.post<unknown>(
                `${this.basepath}/change/cancel`,
                { id }
            );
            if (response?.code === "00") {
                this.changes.next(Date.now());
            }
            return response;
        } catch (err) {
            console.log(err);
        }
    }
}
